export default __webpack_public_path__ + "static/media/decade-loader.07c2e3fa.gif";